import { error, finish } from '../../../modules/system-settings/actions/put-bog-settings';
import api from '../../../api';

export function request(dispatch, { data }) {

    api.put(`/bonus-rules/best-odds-guaranteed`, data ).then(
        response => dispatch(finish( data )),
        (errors) => dispatch(error(errors))
    );
}
